import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Award } from "lucide-react";
import { api } from "@/lib/api";

export default function VerifyCertificate() {
  const { certificateId } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    api.get(`/certificates/verify/${certificateId}`)
      .then((r) => setResult(r.data))
      .catch(() => setResult({ valid: false }));
  }, [certificateId]);

  return (
    <div className="container-x py-24 min-h-[70vh] flex items-center justify-center">
      <div className="max-w-lg w-full text-center">
        {result === null && <div className="text-white/50 text-sm">Doğrulanıyor...</div>}

        {result && result.valid && (
          <div className="bg-surface border border-gold-30 p-10">
            <div className="w-16 h-16 rounded-full bg-gold/10 border border-gold-30 flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-8 h-8 text-gold" />
            </div>
            <div className="section-eyebrow mb-2">Sertifika Doğrulandı</div>
            <h1 className="font-display text-3xl mb-6">Geçerli Sertifika ✓</h1>
            <div className="text-left space-y-3 text-sm border-t border-white/10 pt-6">
              <Row label="Öğrenci" value={result.student_name} />
              <Row label="Eğitim" value={result.course_title} />
              <Row label="Veriliş Tarihi" value={new Date(result.issued_at).toLocaleDateString("tr-TR")} />
              <Row label="Sertifika No" value={result.certificate_id} mono />
            </div>
          </div>
        )}

        {result && !result.valid && (
          <div className="bg-surface border border-red-800/50 p-10">
            <div className="w-16 h-16 rounded-full bg-red-950/40 border border-red-800 flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-8 h-8 text-red-400" />
            </div>
            <h1 className="font-display text-3xl mb-3">Sertifika Bulunamadı</h1>
            <p className="text-white/60 text-sm">
              Bu sertifika numarası sistemimizde kayıtlı değil. Lütfen QR kodu tekrar tarayın veya bizimle iletişime geçin.
            </p>
          </div>
        )}

        <div className="mt-8 flex items-center justify-center gap-2 text-white/40 text-xs">
          <Award className="w-4 h-4" /> ZB Campus Sertifika Doğrulama Sistemi
        </div>
        <Link to="/" className="text-xs text-white/40 hover:text-gold mt-4 inline-block">Ana sayfaya dön</Link>
      </div>
    </div>
  );
}

function Row({ label, value, mono }) {
  return (
    <div className="flex justify-between items-center">
      <span className="text-white/50">{label}</span>
      <span className={`text-white ${mono ? "font-mono text-xs" : ""}`}>{value}</span>
    </div>
  );
}
